import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerInpageNavigationConverter extends CmsConverterService<ColorContainerInpageNavigationData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      iconColor: formData.st_icon_color?.value?.identifier ?? 'orange',
      itemsPerRow: formData.st_items_row?.value?.identifier ?? 6,
      headline: formData.st_subsection_headline ?? defaultTextInput
    }
  }
}

export const COLOR_CONTAINER_INPAGE_NAVIGATION_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerInpageNavigationData>>('ColorContainerInpageNavigationConverter')

export interface ColorContainerInpageNavigationData extends ConvertedComponentData {
  iconColor: string;
  itemsPerRow: number;
  headline: TextInput;
}
